export const ICON_TEST_ID = 'chip-icon';
export const CALENDAR_ICON = 'calendar-icon';
export const SKELETON_LOADING = 'skeleton-loading';
export const AVATAR_SKELETON_LOADING = 'avatar-skeleton-loading';
export const TOOLTIP = (tooltipId: string) => `${tooltipId}-trigger`;
export const ACTION_DIVIDER = 'action-divider';
export const LOADING_OVERLAY = 'loading-overlay';
export const LIST_CONTAINER = 'list-container';
export const INPUT_CLEAR_BUTTON_CONTAINER_TEST_ID = 'clear-button-container';
export const FLOATING_ARROW = 'floating-arrow';
export const DROPSECTION = 'dropsection';
export const INPUT_CONTAINER = (fieldName: string) => `input-container-${fieldName}`;